import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

export default styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  marginLeft: 'auto',
  color: theme.palette.primary.main,
}));
